<div class="modal fade" id="{{modalId}}" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Change Password</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<form [formGroup]="passwordForm" (ngSubmit)="saveData()" #modform="ngForm">
				<div class="modal-body">
					<div class="row mb-3">
						<div class="col">
							<p class="mb-0">
								<strong>Username: </strong>
								{{username}}
							</p>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
							<div class="mb-2">
								<div class="input-group">
									<div class="form-floating">
										<input class="form-control" [type]="hideP ? 'password' : 'text'"
											[ngClass]="{'is-invalid':showError('password')}" id="password"
											formControlName="password" placeholder="">
										<label for="password">Password*</label>
									</div>
									<button type="button" (click)="hideP = !hideP"
										class="btn btn-sm btn-outline-secondary">
										<fa-icon *ngIf="hideP" [icon]="['fas', 'eye']"
											style="font-size: medium;"></fa-icon>
										<fa-icon *ngIf="!hideP" [icon]="['fas', 'eye-slash']"
											style="font-size: medium;"></fa-icon>
									</button>
								</div>
								<p *ngIf="showError('password')" class="text-danger">
									<span *ngIf="f.password.errors?.required">
										Required
									</span>
									<span *ngIf="f.password.errors?.incorrect">
										{{customError.password}}
									</span>
								</p>
							</div>
							<div class="mb-2">
								<div class="form-floating">
									<input class="form-control" type="password"
										[ngClass]="{'is-invalid':showError('confirmPassword')}" id="confirmPassword"
										formControlName="confirmPassword" placeholder="Confirm Password*">
									<label for="confirmPassword">Confirm Password*</label>
								</div>
								<p *ngIf="showError('confirmPassword')" class="text-danger">
									<span *ngIf="f.confirmPassword.errors?.required">
										Required
									</span>
									<span *ngIf="f.confirmPassword.errors?.incorrect">
										{{customError.confirmPassword}}
									</span>
								</p>
								<p *ngIf="passwordForm.errors && (modform.submitted || f.confirmPassword.touched)"
									class="text-danger">
									<span *ngIf="passwordForm.errors?.passwordNotMatch">
										Password and Confirm Password not matched!
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
									</span>
								</p>
							</div>
						</div>
						<div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
							<div *ngIf="showError('password')">
								<p [ngClass]="f.password.errors?.minlengtherror?'text-danger':'text-success'">
									Must be atleast 8 characters long.
								</p>
								<p [ngClass]="f.password.errors?.specialcharerror?'text-danger':'text-success'">
									Must have atleast 1 special character.
								</p>
								<p [ngClass]="f.password.errors?.uppercaseerror?'text-danger':'text-success'">
									Must have atleast 1 upper case character.
								</p>
								<p [ngClass]="f.password.errors?.lowercaseerror?'text-danger':'text-success'">
									Must have atleast 1 lower case character.
								</p>
								<p [ngClass]="f.password.errors?.digiterror?'text-danger':'text-success'">
									Must have atleast 1 digit.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-primary me-1">
						<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						Submit
					</button>
					<button type="button" class="btn btn-sm btn-warning" (click)="clearForm()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>